// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-expandable-button .icon-right {
  padding-left: 10px;
}

.bolt-expandable-button .subtle.active {
  background-color: rgba(0, 0, 0, 0.20);
  background-color: var(--palette-black-alpha-20,rgba(0, 0, 0, 0.20));
}

/*# sourceMappingURL=ExpandableButton.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Button/ExpandableButton.scss","webpack://./../azure-devops-ui/bin/Components/Button/ExpandableButton.css","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;ACAJ;;ADGA;EACI,qCE+Ge;ED/GjB,mEAAmE;AACrE;;AAEA,+CAA+C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
